import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../reducers';

export const impersonationSliceSelector = (state: StorageState) => state.impersonation;

export const impersonationFlag = createSelector(
    impersonationSliceSelector,
    impersonation => impersonation.isImpersonation
);
